/**
 * 숫자 파싱 관련 유틸 함수 모듈
 * @module core/number/parse
 */

/**
 * 숫자 타입으로 변환하고 변환 불가능하면 null 반환
 * @param value 변환할 값
 * @returns 변환된 숫자, null·undefined·빈 문자열이거나 NaN으로 변환되면 null
 */
export const toNullableNumber = (value: unknown): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const num = Number(value);
  return Number.isNaN(num) ? null : num;
};
